import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withRouter, Link } from 'react-router-dom';
import ReactWOW from 'react-wow';

import { Check, X } from 'react-feather';

import {
  Col,
  Media,
  Button,
} from 'reactstrap';

import logo_white from '../../../../assets/images/white padding.png';

class ComparisonTable extends Component {
  static propTypes = {
  };

  static defaultProps = {
    user: {},
  };

  constructor(props) {
    super(props);

    this.state = {
      error: null,
    };
  }

  componentDidMount() {
    const { user } = this.props;

  }


  scrollToTop = () => {
    console.log('scrollToTop');
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });

    const { parentActionFunction } = this.props;

    console.log('parentActionFunction');

    if (parentActionFunction) {
      parentActionFunction();
    }
  }

  goToSignup = (event) => {
    const { history } = this.props;

    if (event.ctrlKey) {
      console.debug("Ctrl+click has just happened!");
    } else {
      window.open('https://app.steppr.com/signup', '_blank').focus();
    }

    this.scrollToTop();
  }

  render() {
    const { user, categories, voucherId, voucher, display, tabChanged, type, newest, notInPage } = this.props;
    const {
      imagesLoaded,
    } = this.state;

    return (
      <>
        <section className="our-achievement comparison-table section">
          <ReactWOW animation='fadeInUp' delay=".4s">
            <div className="container">
              <div className="row comparison-table-header">
                <div className="col-12">
                  <div className="section-title">
                    <h2 className="wow fadeInUp" style={{ color: '#FFF' }} data-wow-delay=".4s">Steppr and Other Platforms</h2>
                    <p className="wow fadeInUp" style={{ color: '#FFF' }} data-wow-delay=".6s">Steppr is the only UK-based platform combining vouchers, gifting, and progressive loyalty with no cost to SMEs.</p>

                  </div>
                </div>
              </div>

              <div className="row comparison-table-row-first">
                <div className="col-4">
                  <div className=" wow fadeInUp" data-wow-delay=".2s">
                    <p></p>
                  </div>
                </div>
                <div className="col-4 comparison-table-col-highlight comparison-table-col-highlight-first">
                  <div className=" wow fadeInUp" data-wow-delay=".2s">
                    <Media src={logo_white} alt="#" />
                    Steppr
                  </div>
                </div>
                <div className="col-4">
                  <div className=" wow fadeInUp" data-wow-delay=".2s">
                    Typical Competitors
                  </div>
                </div>
              </div>

              <div className="row ">
                <div className="col-4">
                  <div className=" wow fadeInUp" data-wow-delay=".2s">
                    <p>No fees</p>
                  </div>
                </div>
                <div className="col-4 comparison-table-col-highlight">
                  <div className=" wow fadeInUp" data-wow-delay=".2s">
                    <Check />
                    <p>No setup fees, no commissions</p>
                  </div>
                </div>
                <div className="col-4">
                  <div className=" wow fadeInUp" data-wow-delay=".2s">
                    <X />
                    <p>Charge 30-50% commission or other fees</p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-4">
                  <div className=" wow fadeInUp" data-wow-delay=".2s">
                    <p>Payout Model</p>
                  </div>
                </div>
                <div className="col-4 comparison-table-col-highlight">
                  <div className=" wow fadeInUp" data-wow-delay=".2s">
                    <Check />
                    <p>Immediate payment on sale</p>
                  </div>
                </div>
                <div className="col-4">
                  <div className=" wow fadeInUp" data-wow-delay=".2s">
                    <X />
                    <p>Payment often delayed until redemption</p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-4">
                  <div className=" wow fadeInUp" data-wow-delay=".2s">
                    <p>Setup</p>
                  </div>
                </div>
                <div className="col-4 comparison-table-col-highlight">
                  <div className=" wow fadeInUp" data-wow-delay=".2s">
                    <Check />
                    <p>No-code, live in minutes</p>
                  </div>
                </div>
                <div className="col-4">
                  <div className=" wow fadeInUp" data-wow-delay=".2s">
                    <X />
                    <p>Often complex and technical</p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-4">
                  <div className=" wow fadeInUp" data-wow-delay=".2s">
                    <p>Campaign Control</p>
                  </div>
                </div>
                <div className="col-4 comparison-table-col-highlight">
                  <div className=" wow fadeInUp" data-wow-delay=".2s">
                    <Check />
                    <p>Set your own rules (discounts, limits, expiry)</p>
                  </div>
                </div>
                <div className="col-4">
                  <div className=" wow fadeInUp" data-wow-delay=".2s">
                    <X />
                    <p>Rigid platform rules</p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-4">
                  <div className=" wow fadeInUp" data-wow-delay=".2s">
                    <p>Loyalty Mechanism</p>
                  </div>
                </div>
                <div className="col-4 comparison-table-col-highlight">
                  <div className=" wow fadeInUp" data-wow-delay=".2s">
                    <Check />
                    <p>Smart progressive discounts encourage repeat purchases</p>
                  </div>
                </div>
                <div className="col-4">
                  <div className=" wow fadeInUp" data-wow-delay=".2s">
                    <X />
                    <p>One-time deals with no loyalty element</p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-4">
                  <div className=" wow fadeInUp" data-wow-delay=".2s">
                    <p>Gifting Options</p>
                  </div>
                </div>
                <div className="col-4 comparison-table-col-highlight">
                  <div className=" wow fadeInUp" data-wow-delay=".2s">
                    <Check />
                    <p>Fully integrated digital gifting</p>
                  </div>
                </div>
                <div className="col-4">
                  <div className=" wow fadeInUp" data-wow-delay=".2s">
                    <X />
                    <p>Few or no gifting options</p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-4">
                  <div className=" wow fadeInUp" data-wow-delay=".2s">
                    <p>Promotion & Exposure</p>
                  </div>
                </div>
                <div className="col-4 comparison-table-col-highlight">
                  <div className=" wow fadeInUp" data-wow-delay=".2s">
                    <Check />
                    <p>Free promotion via our apps and site</p>
                  </div>
                </div>
                <div className="col-4">
                  <div className=" wow fadeInUp" data-wow-delay=".2s">
                    <X />
                    <p>Often pay-to-feature, limited audience</p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-4">
                  <div className=" wow fadeInUp" data-wow-delay=".2s">
                    <p>Analytics Dashboard</p>
                  </div>
                </div>
                <div className="col-4 comparison-table-col-highlight">
                  <div className=" wow fadeInUp" data-wow-delay=".2s">
                    <Check />
                    <p>Real-time sales and redemption tracking</p>
                  </div>
                </div>
                <div className="col-4">
                  <div className=" wow fadeInUp" data-wow-delay=".2s">
                    <X />
                    <p>Premium-only or limited data</p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-4">
                  <div className=" wow fadeInUp" data-wow-delay=".2s">
                    <p>Built For</p>
                  </div>
                </div>
                <div className="col-4 comparison-table-col-highlight">
                  <div className=" wow fadeInUp" data-wow-delay=".2s">
                    <Check />
                    <p>Independent businesses and SMEs</p>
                  </div>
                </div>
                <div className="col-4">
                  <div className=" wow fadeInUp" data-wow-delay=".2s">
                    <X />
                    <p>Generic platforms for mass deals</p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-4">
                  <div className=" wow fadeInUp" data-wow-delay=".2s">
                    <p>Custom Support</p>
                  </div>
                </div>
                <div className="col-4 comparison-table-col-highlight">
                  <div className=" wow fadeInUp" data-wow-delay=".2s">
                    <Check />
                    <p>Personal contact, fast adjustments, flexible onboarding</p>
                  </div>
                </div>
                <div className="col-4">
                  <div className=" wow fadeInUp" data-wow-delay=".2s">
                    <X />
                    <p>Limited and impersonal, or automated</p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-4">
                  <div className=" wow fadeInUp" data-wow-delay=".2s">
                    <p>Branding</p>
                  </div>
                </div>
                <div className="col-4 comparison-table-col-highlight">
                  <div className=" wow fadeInUp" data-wow-delay=".2s">
                    <Check />
                    <p>You stay front-and-centre - we never white-label</p>
                  </div>
                </div>
                <div className="col-4">
                  <div className=" wow fadeInUp" data-wow-delay=".2s">
                    <X />
                    <p>Often dilute your brand under theirs</p>
                  </div>
                </div>
              </div>



              <div className="row comparison-table-row-last">
                <div className="col-4">
                  <div className=" wow fadeInUp" data-wow-delay=".2s">
                    <p></p>
                  </div>
                </div>
                <div className="col-4 comparison-table-col-highlight comparison-table-col-highlight-last">
                  <div className=" wow fadeInUp" data-wow-delay=".2s">
                    <p></p>
                  </div>
                </div>
                <div className="col-4">
                  <div className=" wow fadeInUp" data-wow-delay=".2s">
                    <p></p>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <Button color=" primary" className="comparison-table-bottom-section-button" onClick={(e) => { this.goToSignup(e) }}>
                Join Steppr Now
              </Button>
            </div>
          </ReactWOW>
        </section>
      </>
    );
  }
}

export default withRouter(ComparisonTable);
